import React from 'react';
import { Box, styled, Link } from '@mui/material';
import AppLogo from '../assets/AMOWhiteLogo.png';
import facebookIcon from '../assets/facebook.svg';
import instagramIcon from '../assets/instagram.svg';
import youtubeIcon from '../assets/youtube.svg';
import linkedInIcon from '../assets/linkedIn.svg';
import { useTranslation } from 'react-i18next';
import { StyledRowBox } from '../theme/StyledElements';

const StyledSocialMediaNavigation = styled(Box)(() => ({
    backgroundColor: '#134C03',
    width: '100vw',
    display: 'flex',
    padding: '10px 100px',
    justifyContent: 'space-between'
}));

const StyledBottomNavigation = styled(Box)(() => ({
    backgroundColor: '#002400',
    paddingBottom: '10px',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}));

const StyledFooterLink = styled(Link)(() => ({
    padding: '10px',
    letterSpacing: '0px',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontFamily: 'Helvetica Neue, sans-serif'
}));

const StyledImage = styled('img')(() => ({
    height: '62px',
    width: '80px',
    margin: '3px'
}));

const StyledSocialMediaIcons = styled('img')(() => ({
    height: '35px',
    width: '35px',
    margin: '15px'
}));

export function Footer(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Box>
            <StyledSocialMediaNavigation>
                <StyledImage src={AppLogo} />
                <StyledRowBox>
                    <Link
                        href="https://www.youtube.com/channel/UCku-tYZILZE00v_VCjsfX6A/featured"
                        target="_blank">
                        <StyledSocialMediaIcons src={youtubeIcon} />
                    </Link>
                    <Link href="https://www.instagram.com/amo_ventedirecte/?hl=fr" target="_blank">
                        <StyledSocialMediaIcons src={instagramIcon} />
                    </Link>
                    <Link href="https://www.linkedin.com/company/71547340/admin/" target="_blank">
                        <StyledSocialMediaIcons src={linkedInIcon} />
                    </Link>
                    <Link href="https://www.facebook.com/amo.ventedirecte" target="_blank">
                        <StyledSocialMediaIcons src={facebookIcon} />
                    </Link>
                </StyledRowBox>
            </StyledSocialMediaNavigation>
            <StyledBottomNavigation>
                <StyledRowBox>
                    <StyledFooterLink
                        href="https://www.amo.farm/mentions-legales/"
                        variant="caption"
                        target="_blank">
                        {t('legalNotice')}
                    </StyledFooterLink>
                    <StyledFooterLink
                        href="https://www.amo.farm/conditions-generales-dutilisation-et-de-vente-damo/"
                        variant="caption"
                        target="_blank">
                        {t('cgu')}
                    </StyledFooterLink>
                    <StyledFooterLink
                        href="https://www.amo.farm/politique-de-confidentialite/"
                        variant="caption"
                        target="_blank">
                        {t('privacyPolicy')}
                    </StyledFooterLink>
                    <StyledFooterLink
                        href="https://www.amo.farm/nous-contacter/"
                        variant="caption"
                        target="_blank">
                        {t('helpAndContact')}
                    </StyledFooterLink>
                    <StyledFooterLink
                        href="https://www.amo.farm/amo-le-blog/"
                        variant="caption"
                        target="_blank">
                        {t('ourBlog')}
                    </StyledFooterLink>
                </StyledRowBox>
                <Box>
                    <StyledFooterLink href="/" variant="caption">
                        {t('footerCopyright')}
                    </StyledFooterLink>
                </Box>
            </StyledBottomNavigation>
        </Box>
    );
}
